import { motion, useReducedMotion } from "framer-motion";
import { HERO, CONTACT } from "../data/content";

export const Hero = () => {
  const reduce = useReducedMotion();

  return (
    <section id="home" data-testid="hero-section" className="grain relative flex min-h-screen items-end overflow-hidden">
      <div className="absolute inset-0" aria-hidden="true">
        <motion.img
          src={HERO.image}
          alt=""
          className="h-full w-full object-cover"
          initial={reduce ? false : { scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2.4, ease: "easeOut" }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-28 pt-44 lg:px-10">
        <motion.p
          className="eyebrow"
          data-testid="hero-eyebrow"
          initial={reduce ? false : { opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          Legacy Custom Homes — {CONTACT.area}
        </motion.p>
        <motion.h1
          className="mt-6 max-w-4xl font-serif text-5xl font-medium leading-[1.08] tracking-tight text-white sm:text-6xl lg:text-7xl"
          data-testid="hero-headline"
          initial={reduce ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35 }}
        >
          Built for the Way <span className="text-gold">You</span> Live.
        </motion.h1>
        <motion.p
          className="mt-8 max-w-xl text-base leading-relaxed text-gray-300 md:text-lg"
          data-testid="hero-subtext"
          initial={reduce ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          {HERO.sub}
        </motion.p>
        <motion.div
          className="mt-10 flex flex-col gap-4 sm:flex-row"
          initial={reduce ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.65 }}
        >
          <a
            href="#contact"
            data-testid="hero-cta-primary"
            className="inline-flex items-center justify-center bg-gold px-9 py-4 font-accent text-xs font-semibold uppercase tracking-[0.25em] text-black transition-colors duration-300 hover:bg-gold-hover focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-black"
          >
            Start Your Project
          </a>
          <a
            href="#projects"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center justify-center border border-white/25 px-9 py-4 font-accent text-xs font-semibold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:border-white hover:bg-white hover:text-black focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-black"
          >
            View Our Work
          </a>
        </motion.div>
      </div>
    </section>
  );
};
